import {
  createEntityAdapter,
  createSlice,
  current,
  PayloadAction
} from '@reduxjs/toolkit'
import { union, uniq } from 'lodash-es'
import { normalize } from 'normalizr'

import { INetwork, INetworkNormalized } from '$/types'
import { networkSchema } from 'app/entities/schema/networkSchema'
import { setFilteredNetworkListSync } from 'app/layout/Navbar/Filters/globalFilterSlice'

export const networksAdapter = createEntityAdapter<INetwork, string>({
  selectId: (network) => network.id.toString()
})

const networksSlice = createSlice({
  name: 'networks',
  initialState: networksAdapter.getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setFilteredNetworkListSync,
      (state, action: PayloadAction<INetwork[] | undefined>) => {
        const normalized = normalize<INetwork[], INetworkNormalized>(
          action.payload,
          [networkSchema]
        )

        if (normalized.entities.networks != null) {
          // NOTE: As filtered network may not contain all lines, we need
          //       to ensure that lines are not removed when merging with
          //       existing networks dataset.
          const prevNetworks = current(state.entities)
          const newNetworks = normalized.entities.networks

          for (const [id, network] of Object.entries(newNetworks)) {
            const prevNetwork = prevNetworks[id]

            if (prevNetwork != null) {
              // NOTE: Normalized entity object reference do not match interface
              network.continuousRoutes = uniq(
                union(network.continuousRoutes, prevNetwork.continuousRoutes)
              ).sort(
                (a, b) => (a as unknown as number) - (b as unknown as number)
              )
            }
          }

          // NOTE: Upsert instead of set operation because new networks
          //       result may filter out old networks
          networksAdapter.upsertMany(state, newNetworks)
        }
      }
    )
  }
})

export default networksSlice.reducer
